import {AnnotationEngine} from './annotationEngine';

/**
 * One engine per viewer session id so annotation strokes survive when the receiver tile is
 * reparented (e.g. focused main ↔ thumbnail strip). {@link ReceiverAnnotationOverlay} remounts
 * in those cases; without shared state the canvas would reset.
 */
const receiverEngines = new Map<string, AnnotationEngine>();

export function getSharedReceiverAnnotationEngine(sessionId: string): AnnotationEngine {
    let e = receiverEngines.get(sessionId);
    if (!e) {
        e = new AnnotationEngine();
        receiverEngines.set(sessionId, e);
    }
    return e;
}

/** Clear strokes for a session without disposing the shared engine (used for director “clear all”). */
export function clearSharedReceiverAnnotationStrokes(sessionId: string): void {
    receiverEngines.get(sessionId)?.clear();
}

export function releaseReceiverAnnotationEngine(sessionId: string): void {
    const e = receiverEngines.get(sessionId);
    if (e) {
        e.clear();
    }
    receiverEngines.delete(sessionId);
}

export function clearReceiverAnnotationEngines(): void {
    receiverEngines.clear();
}
